import Link from '../components/Link'
import React from 'react'
import { Button, Col, Container, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap'

import NewsletterSubscriptionForm from '../components/NewsletterSubscriptionForm'

import styles from './Footer.module.scss'

export default () => (
  <Container className={ styles.footer } fluid>
    <Row>
      <Col xs={ 12 } md={ 8 }>
        <h2>Less complexity.</h2>
        <div className="lead">
          <p>Too much of software development today is focused on accidental complexity. We’re creating a holistic language, editor, and infrastructure to allow engineers to build distributed backends.</p>
          <p>We abstract away individual machines and low-level distributed systems code to:</p>
          <ul>
            <li>Generate and run scalable infrastructure for you.</li>
            <li>Remove the deployment step entirely.</li>
            <li>Use APIs as easily as functions.</li>
          </ul>
          <p><Link to="/whydark">More about why we built Dark &rarr;</Link></p>
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={ 12 } md={ 5 }>
        <NewsletterSubscriptionForm />
      </Col>
    </Row>
    <Row className={ styles.links }>
      <Col>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/team">Team</Link></li>
          <li><Link to="/values">Values</Link></li>
          <li><Link to="/careers">Careers</Link></li>
          <li><a href="https://medium.com/darklang">Blog</a></li>
        </ul>
      </Col>
    </Row>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js